import auth0 from 'auth0-js';
import _ from 'lodash';
import decode from 'jwt-decode';
import queryString from 'query-string';

import { EventEmitter } from 'events';

import { isTokenExpired } from './jwt-helper';

const loginDefaultArgs = {
  realm: 'Username-Password-Authentication',
};

const CORQ_DOMAIN = 'data.corq.studio';
const CORQ_REFERRER = 'corq.studio';
const IMPERSONATOR_DOMAIN = 'imp.dyzio.co';
const AUTH0_ISSUER = 'dyzio.eu.auth0.com';

class Auth extends EventEmitter {
  isImperonatorDomain = () => {
    const { hostname } = window.location;
    return hostname === IMPERSONATOR_DOMAIN;
  }

  auth0 = new auth0.WebAuth({
    domain: this.isImperonatorDomain() ? AUTH0_ISSUER : process.env.REACT_APP_AUTH0_DOMAIN,
    clientID: process.env.REACT_APP_AUTH0_CLIENT_ID,
    redirectUri: `${window.location.origin}/auth`,
    responseType: 'token',
  });

  uid = () => {
    const profile = this.getProfile();
    return profile ? profile.app_metadata.dyzio.u_id : null;
  }

  socialLogin = args => this.auth0.authorize(args);

  parseHash = () => new Promise((resolve, reject) => {
    const { hostname } = window.location;
    const parsedHash = queryString.parse(window.location.hash);
    const { referrer } = parsedHash;
    if (hostname === CORQ_DOMAIN && referrer === CORQ_REFERRER) {
      const decoded = decode(parsedHash.id_token);
      localStorage.setItem('id_token', parsedHash.id_token);
      localStorage.setItem('profile', JSON.stringify(decoded));
      this.emit('profile_updated', decoded);
      resolve();
    } else {
      this.auth0.parseHash({
        hash: window.location.hash,
        __enableIdPInitiatedLogin: true,
      }, (err, authResult) => {
        if (err) {
          reject(err);
        }
        if (authResult && authResult.accessToken && authResult.idToken) {
          this.auth0.client.userInfo(authResult.accessToken, (error, profile) => {
            if (error) {
              reject(error);
            }
            localStorage.setItem('id_token', authResult.idToken);
            localStorage.setItem('profile', JSON.stringify(profile));
            this.emit('profile_updated', profile);
            resolve();
          });
        } else {
          reject('Missing token.');
        }
      });
    }
  })

  getProfile = () => {
    const profile = localStorage.getItem('profile');
    return profile ? JSON.parse(profile) : {};
  }

  loggedIn = () => {
    const token = this.getToken();
    return !!token && !isTokenExpired(token);
  }

  logout = () => {
    localStorage.removeItem('id_token');
    localStorage.removeItem('profile');
    localStorage.removeItem('dyzio-upgrade-modal');
  }

  login = (args, onError) => this.auth0.login(_.assign(loginDefaultArgs, args), onError);

  signup = (args, onError) => this.auth0.redirect.signupAndLogin(args, onError);


  getToken = () => localStorage.getItem('id_token');
}

export const authService = new Auth();



/** WEBPACK FOOTER **
 ** ./src/utils/auth-service.js
 **/